var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guest-wrapper" }, [
    _c("div", { staticClass: "remove guest-header" }, [
      _vm.ModifyReservationAdditionalGuestFormTitle
        ? _c("div", { staticClass: "guest-label" }, [
            _vm._v(
              " " + _vm._s(_vm.ModifyReservationAdditionalGuestFormTitle) + " "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("button", {
        staticClass: "icon-close",
        attrs: { "aria-label": _vm.tc("booking.close") },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.$emit("remove")
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex-grid-2-col gutter-md guest-block" }, [
      _c("input", {
        attrs: {
          type: "hidden",
          "data-default-value": _vm.confirmationNumber,
          "data-val": "true",
          id: "additional-guest-confirmation-" + _vm.index,
          name: "additional-guest-confirmation-" + _vm.index,
        },
        domProps: { value: _vm.confirmationNumber },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input" }, [
        _c("input", {
          attrs: {
            type: "text",
            "data-default-value": _vm.guestFirstName,
            id: "additional-guest-firstname-" + _vm.index,
            name: "additional-guest-firstname-" + _vm.index,
            maxlength: "255",
            "data-val": "true",
            "data-rule-minlength": "1",
            "data-rule-maxlength": "50",
            "data-msg-minlength": _vm.getValidationForField("minChars", "1"),
            "data-msg-maxlength": _vm.getValidationForField("maxChars", "50"),
            "data-val-no-special-chars": _vm.tc("validations.noSpecialChars"),
            "data-field-type": "SingleLineText",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "floating",
            attrs: { for: "additional-guest-firstname-" + _vm.index },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.tc("formFields.firstName")) + "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", {
          staticClass: "field-validation-valid",
          attrs: {
            "data-valmsg-for": "additional-guest-firstname-" + _vm.index,
            "data-valmsg-replace": "true",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input" }, [
        _c("input", {
          staticClass: "req",
          attrs: {
            type: "text",
            "data-default-value": _vm.guestLastName,
            id: "additional-guest-lastname-" + _vm.index,
            name: "additional-guest-lastname-" + _vm.index,
            maxlength: "255",
            "data-val": "true",
            "data-rule-minlength": "1",
            "data-rule-maxlength": "65",
            "data-msg-minlength": _vm.getValidationForField("minChars", "1"),
            "data-msg-maxlength": _vm.getValidationForField("maxChars", "65"),
            "data-val-no-special-chars": _vm.tc("validations.noSpecialChars"),
            "data-val-required": _vm.getValidationForField(
              "required",
              "lastName"
            ),
            "data-field-type": "SingleLineText",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "req floating",
            attrs: { for: "additional-guest-lastname-" + _vm.index },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.tc("formFields.lastName")) + "\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", {
          staticClass: "field-validation-valid",
          attrs: {
            "data-valmsg-for": "additional-guest-lastname-" + _vm.index,
            "data-valmsg-replace": "true",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }